import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';

import {updateAgentValues} from 'ApplicationEntry/ducks/agentInformation';
import {removeAgent} from 'ApplicationEntry/ducks/agentList';
import {AgentInformation} from 'ApplicationEntry/models/AgentInformation';
import {AgentList} from 'ApplicationEntry/models/AgentList';
import {InvalidApplication, ValidApplication} from 'ApplicationEntry/models/Application';

import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';

import './../ContingentBeneficiary/ContingentBeneficiary.sass';

import AgentDialog from './AgentDialog';

type AgentTabularProps = {
  agentItem: AgentList;
  application: InvalidApplication | ValidApplication;
};

export default function AgentTabularList(props: AgentTabularProps) {
  const dispatch = useDispatch();

  const [openDeleteBox, setOpenDeleteBox] = useState(false);
  const [Index, setIndex] = useState(0);
  const [openEditBox, setOpenEditBox] = useState(false);

  const handleClickOpen = (index: number) => {
    setOpenDeleteBox(true);
    setIndex(index);
  };

  const handleEditAgent = (index: number) => {
    setIndex(index);
    const agentItems = props.agentItem.agentList.get(index) as AgentInformation;

    dispatch(
      updateAgentValues(
        agentItems.agentNumber,
        agentItems.agentName,
        agentItems.percent,
        agentItems.signed,
        agentItems.allstateAffiliated
      )
    );
    setOpenEditBox(true);
  };

  const handleClose = () => {
    setOpenDeleteBox(false);
    setOpenEditBox(false);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table className="contingent-beneficiary-section__table">
          <TableHead>
            <TableRow>
              <TableCell>Agent </TableCell>
              <TableCell>Agent Name</TableCell>
              <TableCell>Percent</TableCell>
              <TableCell>Signed</TableCell>
              <TableCell>Allstate Affiliated</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.agentItem.agentList.map((item, index) => {
              return (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    {(item.agentNumber.key === 'UserAssignedAgentNumber' ||
                      item.agentNumber.key === 'AgentNumberError') &&
                      item.agentNumber.value}
                  </TableCell>
                  <TableCell>{item.agentName.value}</TableCell>
                  <TableCell>{item.percent}%</TableCell>
                  <TableCell>
                    <Checkbox disabled checked={item.signed} name="checkedSigned" color="secondary" />
                  </TableCell>
                  <TableCell>
                    <Checkbox disabled checked={item.allstateAffiliated} name="allstateAffiliated" color="secondary" />
                  </TableCell>
                  <TableCell>
                    <ActionsMenu>
                      <MenuItem key="contingent-beneficiary-edit" onClick={() => handleEditAgent(index)}>
                        Edit
                      </MenuItem>
                      <MenuItem key="contingent-beneficiary-delete" onClick={() => handleClickOpen(index)}>
                        Delete
                      </MenuItem>
                    </ActionsMenu>
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell className="contingent-beneficiary-section__table-total-count">Item Count:</TableCell>
              <TableCell className="contingent-beneficiary-section__table-total-count">
                {props.agentItem.agentList.size}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {props.agentItem.agentList.size > 0 ? (
        <Dialog
          open={openDeleteBox}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary" style={{color: 'red'}}>
            Delete Agent
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Agent will be removed from the list. Do you want to delete{' '}
              <span style={{fontWeight: 'bold'}}>{props.agentItem.agentList.toArray()[Index].agentName.value}</span>?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                setOpenDeleteBox(false);
                setIndex(0);
                dispatch(removeAgent(Index));
              }}
              color="primary"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
      <AgentDialog
        dialogOpen={openEditBox}
        dialogClose={handleClose}
        dialogTitle="Add Agent(s)"
        dialogSubTitle="Agent(s) Information"
        dialogAdditional="ADDITIONAL AGENT"
        agentIndex={Index}
        application={props.application}
        editAgent={openEditBox}
      />
    </>
  );
}
